import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaTwitter, FaEnvelope, FaHeart, FaRocket } from 'react-icons/fa';

const Footer = () => {
  const socialLinks = [
    { icon: FaGithub, href: '#', label: 'GitHub' },
    { icon: FaLinkedin, href: '#', label: 'LinkedIn' },
    { icon: FaTwitter, href: '#', label: 'Twitter' },
    { icon: FaEnvelope, href: 'mailto:abrardev@abrarshaikh.com', label: 'Email' }
  ];

  return (
    <motion.footer 
      className="footer-futuristic"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      <div className="footer-glow"></div>
      <div className="container">
        <div className="footer-content">
          <motion.div 
            className="footer-brand"
            whileHover={{ scale: 1.05 }}
          >
            <h3>Abrar Shaikh</h3>
            <p>Full Stack Developer</p>
          </motion.div>

          <div className="footer-social">
            <h4>Connect With Me</h4>
            <div className="social-links">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.href}
                  className="social-link"
                  whileHover={{ 
                    scale: 1.3, 
                    rotate: 360,
                    boxShadow: "0 0 20px #00f5ff"
                  }}
                  whileTap={{ scale: 0.9 }}
                  aria-label={social.label}
                >
                  <social.icon />
                </motion.a>
              ))}
            </div>
          </div>
        </div>

        <motion.div 
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <div className="footer-divider"></div>
          <p className="copyright">
            Made with <motion.span 
              className="heart"
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ repeat: Infinity, duration: 1.5 }}
            >
              <FaHeart />
            </motion.span> by Abrar Shaikh © 2024
          </p>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer;